import { ChangeEvent, useState, useEffect, useMemo, useRef } from 'react';
import {
  Divider,
  Box,
  FormControl,
  InputLabel,
  Card,
  Table,
  TableBody,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  Select,
  MenuItem,
  Typography,
  TextField,
  Grid,
  Button,
  InputAdornment,
  CardHeader,
  ListSubheader
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import moment from 'moment';
import { useNavigate } from 'react-router';
import { withStyles } from '@mui/styles';
import { EmployeeInformation } from 'src/models/employee';
import { AppActions } from 'src/store/AppReducer';
import { filteredDropdownList, getAssignedRequests } from 'src/services/leaveService';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import { leaveRequestStatus, userRoles } from 'src/models/leave.enum';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useForm } from 'react-hook-form';
import { filterForApprovedAndRejectedLeaves } from 'src/models/leave';
import { DatePicker } from '@mui/lab';
interface Filters {
  status?: any;
}

const RejectedLeaves = (props) => {
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  //temporally added due to technical issue in BE pagination(currentPageNo, currentPageSize)
  const currentPageNo: number = 1;
  const currentPageSize: number = 1000;

  const [filters] = useState<Filters>({ status: null });
  const [toggleFilter, setToggleFilter] = useState(false);

  const [sortNameType, setSortNameType] = useState('');
  const [leaveType, setLeaveType] = useState(' ');
  const [requestorName, setRequestorName] = useState(' ');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [leave, setLeave] = useState<any>([]);
  const initalList: EmployeeInformation[] = [];
  const [allEmployees, setAllEmployees] = useState<any>(initalList);
  const [searchString, setSearchString] = useState('');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const [searchText, setSearchText] = useState<any>('');
  const inputRefFrom = useRef<HTMLInputElement>(null);
  const inputRefTo = useRef<HTMLInputElement>(null);
  const [isDisabled, setIsDisable] = useState(true);
  const [leaveList, setLeaveList] = useState<any>([]);
  const [isDisabledClearBtn, setIsDisabledClearBtn] = useState<boolean>(true);

  const [sortDate, setSortDate] = useState('asc');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (leaveList?.length > 0 && sortNameType === 'asc') {
      setLeaveList(leaveList.sort((a, b) => a.leaveRequester.name.localeCompare(b.leaveRequester.name)));
    } else if (leaveList?.length > 0 && sortNameType === 'desc') {
      setLeaveList(leaveList.sort((a, b) => b.leaveRequester.name.localeCompare(a.leaveRequester.name)));
    }
  }, [sortNameType]);

  useEffect(() => {
    if (leaveList?.length && sortDate === 'asc') {
      setLeaveList(leaveList.sort((a, b) => a.id - b.id));
    } else if (leaveList?.length && sortDate === 'desc') {
      setLeaveList(leaveList.sort((a, b) => b.id - a.id));
    }
  }, [sortDate]);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
    // sendData(page > 0 ? page : 1, parseInt(event.target.value));
  };

  const applyFilters = (leaveList: any[]): any[] => {
    return leaveList.filter(() => {
      let matches = true;
  
      return matches;
    });
  };
  
  const applyPagination = (
    leaveList: any[],
    page: number,
    limit: number
  ): any[] => {
    return leaveList.slice(page * limit, page * limit + limit);
  };

  const NavigateToEditSection = (employeeId: number, view) => {
    navigate('edit-employee/' + employeeId);
    navigate(`edit-employee/${employeeId}?view=${view}`);
  };

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const leaveTypes = useMemo(
    () =>
      leave?.filter((option) => containsText(option, searchText)),
    [searchText, leave]
  );

  const displayedEmployee = useMemo(
    () =>
      allEmployees?.filter((option) => containsText(option, searchText)),
    [searchText, allEmployees]
  );

  // custom table row with different color
  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  const sendData = (pageNo, pageSize) => {
    const data = {
      pageNo: pageNo,
      pageSize: pageSize,
      status: leaveRequestStatus.REJECTED
    }
    props.onDataChange(data);
  }

  const filteredLeaveRequestList = applyFilters(leaveList);

  const paginatedLeaveList = applyPagination(filteredLeaveRequestList, page, limit);

  const getDropdownList = (role, status) => {
    dispatch(AppActions.showLoader())
    filteredDropdownList(currentPageNo, currentPageSize, role, status)
      .then(res => {
        if (res.data.data) {
          const leaveTypeList = res.data.data.leaveTypes.map(item => item);
          const leaveRequestorList = res.data.data.leaveRequesters.map(item => item);

          setLeave(leaveTypeList.filter((item, index) =>
            leaveTypeList.indexOf(item) === index));
          setAllEmployees(leaveRequestorList.filter((item, index) =>
            leaveRequestorList.indexOf(item) === index));
        }
        dispatch(AppActions.hideLoader());
      })
      .catch(e => {
        dispatch(AppActions.hideLoader());
      });
  }

  const validateUserRole = (userRole) => {
    const user_role = userRole.split(',');
    if (user_role.includes(userRoles.HR_Manager) ||
      user_role.includes(userRoles.SUPER_USER)) {
      return 'HR_MANAGER';
    } else if (user_role.includes(userRoles.ASSISTANT_HR_MANAGER)) {
      return 'ASSISTANT_HR_MANAGER';
    } else if (user_role.includes(userRoles.HR_EXECUTIVE)) {
      return 'HR_EXECUTIVE';
    } else {
      return 'REPORTING_MANAGER';
    }
  }

  const NavigateToViewSection = () => {
    props.onView(props?.leaveDetails)
  };

  const initialDate = (isFromDate: Boolean) => {
    if (!isFromDate && fromDate) {
      const minDate = new Date(fromDate.split('/').reverse().join('-'));
      return minDate.toISOString().split("T")[0]
    } else {
      if (toDate) {
        const minDate = new Date(toDate.split('/').reverse().join('-'));
        return minDate.toISOString().split("T")[0]
      }
    }
    return null;
  }

  useEffect(() => {
    const makeApiCall = async () => {
      if (searchString) {
        getFilteredData();
      } else {
        getDropdownList(leaveRequestStatus.REJECTED, validateUserRole(user.Roles));
        if (props.leaveDetails?.length) {
          //reorder by latest from date
          //const reorderByFormDate = props?.leaveDetails.sort((a,b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime());
          setLeaveList(props?.leaveDetails);
        }
      }
    }

    const triggerCall = setTimeout(() => {
      makeApiCall()
    }, 500)

    return () => clearTimeout(triggerCall)
  }, [searchString, props.leaveDetails])

  const [isSelectToDate, setIsSelectToDate] = useState('');
  const [isSelectFromDate, setIsSelectFromDate] = useState('');
  const [ selectFormDate, setSelectFormDate] = useState('');
  const [selectToDate, setSelectToDate] = useState('');

  //filter option
  const { getValues } = useForm<filterForApprovedAndRejectedLeaves>();

  const modifiedString = () => {
    let filter = getValues()
    filter.isEmpty = true;
    if (searchString) {
      filter.mainSearchParam = searchString;
      filter.isEmpty = false;
    }

    if (requestorName !== ' ') {
      filter.requesterName = requestorName;
      filter.isEmpty = false;
    }

    if (leaveType !== ' ') {
      filter.leaveType = leaveType;
      filter.isEmpty = false;
    }

    if (fromDate) {
      filter.fromDate = fromDate;
      filter.isEmpty = false;
    }

    if (toDate) {
      filter.toDate = toDate;
      filter.isEmpty = false;
    }

    if (!filter.isEmpty) {
      return JSON.stringify(filter)
        .replace('"isEmpty":false,', '')
        .replace('{', '')
        .replace('}', '')
        .replace(/\"/g, '');
    } else {
      return null;
    }
  };

  const getFilteredData = () => {
    dispatch(AppActions.showLoader());
    
    let leaveStatus: string = leaveRequestStatus.REJECTED;
    let isEligible: boolean = null;
    let leaveType: string = '';
    let hrApproved: boolean = false;
    let filter = modifiedString();
    let isLeaveCountRequired = true;

    getAssignedRequests(leaveStatus, currentPageNo, currentPageSize, validateUserRole(user.Roles), isEligible, leaveType, hrApproved, filter, isLeaveCountRequired)
    .then((res) => {
      if (res.data.statusCode === 200) {
        if (res.data?.data) {
          setPage(0);
          //reorder by latest from date
          //const reorderByFormDate = res.data?.data?.leaveAssignedList.sort((a,b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime());
          setLeaveList(res.data?.data?.leaveAssignedList);
        }
        dispatch(AppActions.hideLoader());
      }
    }).catch((e) => {
      dispatch(AppActions.hideLoader());
    });
  }

  //set disabled filter button
  const filterMandatoryFled = (e) => {
    if (e) {
      fromDate
        ? toDate
          ? setIsDisable(false)
          : setIsDisable(true)
        : toDate
        ? fromDate
          ? setIsDisable(false)
          : setIsDisable(true)
        : setIsDisable(false);
    }
  };

  return (
    <>
      <Card sx={{ width: '100%', minHeight: '25rem' }}>
        <Grid sx={{ px: 2, py: 2 }} item xs={12}>
          <TextField
            sx={{ width: 320, mr: 2 }}
            size="small"
            id="search-field"
            placeholder="Search (Requestor Name / Leave Type)"
            InputProps={{
              style: { fontSize: '12px', height: '1.75rem'},
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{ color: '#d3d3d3' }}
                    style={{ fontSize: '15px' }}
                  />
                </InputAdornment>
              )
            }}
            onChange={e => setSearchString(e.target.value)}
          />
          <Button
            sx={{
              mt: { xs: 2, md: 0 },
              color: `${!toggleFilter && 'gray'}`
            }}
            variant="outlined"
            startIcon={<FilterListIcon style={{ fontSize: '15px' }} />}
            style={{ height: '1.75rem', fontSize: '12px' }}
            onClick={() => {
              setToggleFilter(!toggleFilter);
              setIsSelectToDate('');
              setIsSelectFromDate('');
              setFromDate('');
              setToDate('');
              setRequestorName(' ');
              setLeaveType(' ');
              setSelectFormDate('');
              setSelectToDate('');
              setIsDisable(true);
              setIsDisabledClearBtn(true);
            }}
          >
            Filters
          </Button>
        </Grid>
        {toggleFilter && (
          <Grid px={2} pb={2} style={{margin: 0}}>
            <form>
              <Grid
                container
                spacing={2}
                style={{
                  justifyContent: 'between'
                }}
              >
              <Grid sx={{display: 'flex'}} xs={12} item>
                <Grid
                  item
                  xs={3}
                  style={{
                    marginRight: '1rem'
                  }}
                >
                  <InputLabel
                    style={{
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    Requestor Name
                  </InputLabel>
                  <FormControl fullWidth>
                    <Select
                      sx={{ mt: 1 }}
                      style={{
                        fontSize: '12px',
                        height: '2rem'
                      }}
                      fullWidth
                      size="small"
                      value={requestorName || ' '}
                      defaultValue=' '
                      onClose={() => {
                        setSearchText('');
                      }}
                      onChange={(e) => {
                        setRequestorName(e.target.value);
                        filterMandatoryFled(e.target.value);
                        setIsDisabledClearBtn(false);
                      }}
                    >
                      <ListSubheader>
                        <TextField
                          size="small"
                          autoFocus
                          placeholder="Type to search..."
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            )
                          }}
                          onChange={(e) => setSearchText(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key !== 'Escape') {
                              // Prevents autoselecting item while typing (default Select behaviour)
                              e.stopPropagation();
                            }
                          }}
                        />
                      </ListSubheader>
                      <MenuItem
                        selected
                        disabled
                        value=' '
                        style={{ display: 'none' }}>
                        Select Name
                      </MenuItem>
                      {displayedEmployee &&
                        displayedEmployee?.map((element, i) => (
                          <MenuItem key={i} value={element}>
                            {element}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={3}
                  style={{
                    marginRight: '1rem'
                  }}
                >
                  <InputLabel
                    style={{
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    Leave Type
                  </InputLabel>
                  <FormControl fullWidth>
                    <Select
                      sx={{ mt: 1 }}
                      id="leaveType"
                      style={{
                        fontSize: '12px',
                        height: '2rem'
                      }}
                      fullWidth
                      size="small"
                      value={leaveType || ' '}
                      defaultValue={' '}
                      onClose={() => {
                        setSearchText('');
                      }}
                      onChange={(e) => {
                        setLeaveType(e.target.value);
                        filterMandatoryFled(e.target.value);
                        setIsDisabledClearBtn(false);
                      }}
                    >
                      <MenuItem
                        style={{ display: 'none' }}
                        selected
                        disabled
                        value={' '}>
                        Select Type
                      </MenuItem>
                      <ListSubheader>
                        <TextField
                          size="small"
                          autoFocus
                          placeholder="Type to search..."
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            )
                          }}
                          onChange={(e) => {
                            setSearchText(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key !== 'Escape') {
                              // Prevents autoselecting item while typing (default Select behaviour)
                              e.stopPropagation();
                            }
                          }}
                        />
                      </ListSubheader>
                      {leaveTypes &&
                        leaveTypes?.map((element, index) => (
                          <MenuItem key={index} value={element}>
                            {element}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={3}
                  style={{
                    marginRight: '1rem'
                  }}
                >
                  <InputLabel
                    style={{
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    From
                  </InputLabel>
                  <div style={{ marginTop: 6}}>
                    <FormControl fullWidth>
                      <DatePicker
                        InputProps={{
                          className: 'date-picker-leaveManagement'
                        }}
                        renderInput={(params) => (
                          <TextField {...params} id="filterFormDate" />
                        )}
                        value={selectFormDate ? selectFormDate : null}
                        onChange={(newValue) => {
                          if (newValue) {
                            setIsDisabledClearBtn(false);
                            setIsSelectFromDate('');
                            setFromDate(moment(newValue).format("DD/MM/YYYY"));
                            setSelectFormDate(moment(newValue).format('YYYY-MM-DD'));
                            setToDate('');
                            setSelectToDate('');
                            setIsDisable(true);
                            setIsSelectToDate("To date is mandatory field");
                          }
                        }}
                      />
                    </FormControl>
                    </div>
                  {isSelectFromDate && (
                    <>
                      <Typography
                        style={{
                          fontSize: '11px'
                        }}
                        color="red"
                      >
                        {isSelectFromDate}
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  xs={3}
                >
                  <InputLabel
                    style={{
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    To
                  </InputLabel>
                  <div style={{ marginTop: 6}}>
                    <FormControl fullWidth>
                    <DatePicker
                        disabled={!fromDate}
                        InputProps={{
                          className: 'date-picker-leaveManagement'
                        }}
                        minDate={new Date(selectFormDate)}
                        renderInput={(params) => (
                          <TextField {...params} id="filterToDate" />
                        )}
                        value={selectToDate ? selectToDate : null}
                        onChange={(newValue) => {
                          if (newValue) {
                            setIsDisabledClearBtn(false);
                            setIsSelectToDate('')
                            setToDate(moment(newValue).format("DD/MM/YYYY"));
                            setSelectToDate(moment(newValue).format('YYYY-MM-DD'));
                            if (!fromDate) {
                              setIsDisable(true);
                              setIsSelectFromDate(
                                'Form date is mandatory field'
                              );
                            } else {
                              setIsDisable(false);
                            }
                          }
                        }}
                      />
                    </FormControl>
                    </div>
                  {isSelectToDate && (
                    <>
                      <Typography
                        style={{
                          fontSize: '11px'
                        }}
                        color="red"
                      >
                        {isSelectToDate}
                      </Typography>
                    </>
                  )}
                </Grid>
                </Grid>
                <Grid
                  container
                  style={{
                    justifyContent: 'flex-end',
                    marginTop: 16,
                    marginLeft: 'auto'
                  }}
                  xs={9}
                >
                  <Button
                    sx={{ mt: { xs: 2, md: 0 } }}
                    variant="outlined"
                    style={{ height: '1.75rem', fontSize: '12px', marginRight: '1rem' }}
                    id="emp-filter-clear"
                    disabled = {isDisabledClearBtn}
                    className={isDisabledClearBtn &&'clear-btn'}
                    onClick={() => {
                      setRequestorName(' ');
                      setLeaveType(' ');
                      setFromDate('');
                      setToDate('');
                      setIsSelectToDate('');
                      setIsSelectFromDate('');
                      sendData(1, limit);
                      setIsDisable(true);
                      setIsDisabledClearBtn(true);
                      setSelectFormDate('');
                      setSelectToDate('');
                      if (inputRefFrom.current) {
                        inputRefFrom.current.value = ''
                      }
                      if (inputRefTo.current) {
                        inputRefTo.current.value = ''
                      }
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    sx={{ mt: { xs: 2, md: 0 } }}
                    id="emp-filter-submit"
                    variant="outlined"
                    type="button"
                    style={{ height: '1.75rem', fontSize: '12px' }}
                    onClick={() => getFilteredData()}
                    disabled = {isDisabled}
                    className={isDisabled &&'filter-btn'}
                  >
                    Filter
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        )}
        <Divider />
        <TableContainer className="tableContainer">
          <Table style={{ borderCollapse: 'separate' }} size="small">
            <TableHead>
              <CustomTableRow>
                <TableHeaderCell
                  content="Requestor Name"
                  smallFont
                  sort
                  setSortType={setSortNameType}
                  sortType={sortNameType}
                />
                <TableHeaderCell 
                  content="Requested Date" 
                  smallFont 
                  sort
                  setSortType={setSortDate}
                  sortType={sortDate}/>
                <TableHeaderCell content="Leave Type" smallFont />
                <TableHeaderCell content="Full Day/Half Day" smallFont />
                <TableHeaderCell content="From" smallFont />
                <TableHeaderCell content="To" smallFont />
                <TableHeaderCell content="Days Count" smallFont />
                <TableHeaderCell sticky content="Actions" smallFont />
              </CustomTableRow>
            </TableHead>

            <TableBody>
              {paginatedLeaveList &&
                paginatedLeaveList.map((item) => {
                  return (
                    <TableRow
                      hover
                    >
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          gutterBottom
                          noWrap
                        >
                          {item.leaveRequester?.name}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          gutterBottom
                          noWrap
                        >
                          {item?.leaveRequestDate}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {(item.typeName === 'Lieu Leave' && item.isEligible) ? 'Lieu Leave Eligibility': item.typeName}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                             {item.typeName === 'Short Leave'
                                  ? 'N/A'
                                  : item.dateType
                                  ? 'Full Day'
                                  : 'Half Day'}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.fromDate}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.toDate}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          paddingLeft="1.8rem"
                          variant="body2"
                          style={{ fontSize: '11px' }}
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.numberOfDays}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell sticky>
                        <div
                          style={{ background: 'white', marginLeft: '0.9rem' }}
                        >
                          <VisibilityIcon
                            onClick={() => {
                              navigate(`/leave-management/leave-view/${item.id}?name=rejected`)
                            }}
                            style={{
                              fontSize: '17px',
                              cursor: 'pointer'
                            }}
                          />
                        </div>
                      </TableColumnCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        {paginatedLeaveList?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )}
        <Box p={2}>
          <TablePagination
            sx={{
              fontSize: '12px',
              '.MuiTablePagination-displayedRows': {
                fontSize: '12px'
              },
              '.MuiTablePagination-selectLabel': {
                fontSize: '12px'
              }
            }}
            component="div"
            count={filteredLeaveRequestList?.length ? 
              filteredLeaveRequestList?.length : 0}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
          />
        </Box>
      </Card>
    </>
  );
};

export default RejectedLeaves;
